
import { GET_TEMPLATES } from '@/gql';
import { mapGetters, mapState } from 'vuex';
import { ITemplatesState } from '@/store/modules/templates';
import Pagination from '@/components/Pagination/index.vue';
import Logging from '@/logging';
import ViewsTemplates_languages from '@/views/_templates/languages.graphql';
import TranslationHelper from '@/helpers/translation';
import i18n from '@/i18n';

export default {
	apollo: {
		languages: {
			query: ViewsTemplates_languages,
			variables() {
				return {
					participant: this.selectedParticipantStore
				};
			},
			update(data) {
				this.handleLanguageFilterChange(data.languages.map(language => { return language.locale; }));
				this.fetchTemplates();

				return data.languages;
			}
		}
	},
	components: {
		Pagination
	},
	props: {
		actionCreationMode: {
			type: Boolean,
			required: false,
			default: () => false
		}
	},
	data() {
		return {
			total: 0,
			page: 1,
			searchTerm: '',
			DEFAULT_CHANNEL_FILTERS: [{ value: 'SMS' }, { value: 'EMAIL' }, { value: 'PHONE' }, { value: 'MAIL' }, { value: 'NONE' }],
			DEFAULT_TONE_FILTERS: [{ value: 'FRIENDLY' }],
			selectedParticipant: null,
			availableParticipants: null,
			queryVars: {
				offset: 0,
				limit: 25,
				participant: null,
				legalEntityFilter: {},
				channels: ['SMS', 'EMAIL', 'PHONE', 'MAIL', 'NONE'],
				locales: [],
				toneOfVoices: ['FRIENDLY'],
				searchTerm: '%%',
				orderBy: { channel: 'asc_nulls_last' }
			},
			availableTemplates: [],
			loading: false
		};
	},
	computed: {
		...mapGetters(['env', 'selectedParticipantStore', 'selectedLegalEntityStore']),
		...mapState('templates', {
			channelFilter: (state: ITemplatesState) => state.channelFilter,
			languageFilter: (state) => state.languageFilter,
			toneOfVoiceFilter: (state) => state.toneOfVoiceFilter
		})
	},
	watch: {
		searchTerm(value) {
			this.queryVars.searchTerm = `%${value}%`;
		}
	},
	methods: {
		paginate(data) {
			const newOffset = data.page * data.limit - data.limit;
			this.queryVars.offset = newOffset;
			this.fetchTemplates();
		},
		handleFilter() {
			this.fetchTemplates();
		},
		handleSort({ prop, order }) {
			let gqlOrder: string | null = '';
			let gqlOrderObject = {};

			if (order === 'ascending') {
				gqlOrder = 'asc_nulls_last';
			} else if (order === 'descending') {
				gqlOrder = 'desc_nulls_last';
			} else if (order === null) {
				gqlOrder = null;
			}

			if (gqlOrder === null) {
				// default sort order
				gqlOrderObject['channel'] = 'asc_nulls_last';
			} else if (prop === 'legal_entity_by_reference.registration_name') {
				gqlOrderObject = { legal_entity_by_reference: { registration_name: gqlOrder } };
			} else {
				gqlOrderObject[prop] = gqlOrder;
			}

			this.queryVars.orderBy = gqlOrderObject;
			Logging.log('queryVars: ', this.queryVars);

			this.fetchTemplates();
		},
		onSearch() {
			this.fetchTemplates();
		},
		onReset() {
			this.handleChannelFilterChange(['SMS', 'EMAIL', 'PHONE', 'MAIL', 'NONE']);
			this.handleLanguageFilterChange(this.languages.map(language => { return language.locale; }));
			this.handleToneOfVoiceFilterChange(['FRIENDLY']);
			this.queryVars.searchTerm = '%%';
			this.queryVars.offset = 0;
			this.queryVars.limit = 25;
			this.fetchTemplates();
		},
		fetchTemplates() {
			if (this.selectedParticipantStore) {
				this.loading = true;
				this.queryVars.participant = this.selectedParticipantStore;
				this.queryVars.channels = this.channelFilter;
				this.queryVars.locales = this.languageFilter;
				this.queryVars.toneOfVoices = this.toneOfVoiceFilter;
				if (this.selectedLegalEntityStore) {
					this.queryVars.legalEntityFilter = {
						_or: [
							{ legal_entity: { _eq: this.selectedLegalEntityStore } },
							{ legal_entity: { _is_null: true } }
						]
					};
				}

				this.$apollo
					.query({
						query: GET_TEMPLATES,
						variables: this.queryVars
					})
					.then(({ data }) => {
						Logging.log('GET_TEMPLATES: ', data);
						this.loading = false;
						this.availableTemplates = data.templates;
						this.total = data.total.aggregate.count;
					})
					.catch(e => {
						this.loading = false;
						Logging.error('Error: ', e);
					});
			}
		},
		handleChannelFilterChange(value) {
			this.$store.commit('templates/SET_CHANNEL_FILTER', value);
		},
		handleLanguageFilterChange(value) {
			this.$store.commit('templates/SET_LANGUAGE_FILTER', value);
		},
		handleToneOfVoiceFilterChange(value) {
			this.$store.commit('templates/SET_TONE_OF_VOICE_FILTER', value);
		},
		handleTemplateClick(row) {
			if (this.actionCreationMode) {
				this.$store.commit('risolto/SET_SELECTED_TEMPLATE', row);
			} else {
				const templateReference = row.reference;
				this.$router.push({ name: 'template-detail', params: { id: templateReference, participant: this.selectedParticipantStore } });
			}
		},
		handleOpenInNewTabClick(row) {
			const templateReference = row.reference;
			const path = this.$router.resolve({ name: 'template-detail', params: { id: templateReference, participant: this.selectedParticipantStore } });

			window.open(path.href, '_blank');
		},
		translate_template_id(id) {
			const translation = TranslationHelper.template_id(i18n, id);

			if (translation !== id) {
				return ` (${translation})`;
			} else {
				return '';
			}
		}
	}
};
